import {
  Checkbox,
  FormControlLabel,
  Grid,
  Stack,
  TextField,
} from '@mui/material';
import { memo } from 'react';
import { NumericFormat } from 'react-number-format';

import { textFieldDefaultStyle } from '../../../../../../../components/UI/Typography';
import { StyledDottedDivider, SubsectionTitle } from '../styles';
import { EditableTypologyGroupFields, TypologyGroup } from '../types';

interface BaseProps {
  group: TypologyGroup;
}

interface WithIndexProps extends BaseProps {
  groupIndex: number;
  onGroupChange: <K extends keyof EditableTypologyGroupFields>(
    index: number,
    field: K,
    value: EditableTypologyGroupFields[K]
  ) => void;
}

interface WithoutIndexProps extends BaseProps {
  groupIndex?: never;
  onGroupChange: <K extends keyof EditableTypologyGroupFields>(
    field: K,
    value: EditableTypologyGroupFields[K]
  ) => void;
}

type TypologyGroupSLAProps = WithIndexProps | WithoutIndexProps;

const TypologyGroupSLA = memo((props: TypologyGroupSLAProps) => {
  const { group } = props;

  const handleFieldChange = <K extends keyof EditableTypologyGroupFields>(
    field: K,
    value: EditableTypologyGroupFields[K]
  ): void => {
    if (props.groupIndex !== undefined) {
      props.onGroupChange(props.groupIndex, field, value);
    } else {
      props.onGroupChange(field, value);
    }
  };

  return (
    <Grid item container mt="24px">
      <StyledDottedDivider />
      <SubsectionTitle>Notificações de SLA:</SubsectionTitle>
      <Grid item container xs={12} spacing={3}>
        <Grid item xs={6}>
          <NumericFormat
            label="aviso de proximidade (dias antes do vencimento)"
            helperText="notificar quando a OS estiver próxima do vencimento"
            customInput={TextField}
            value={group.slaAlertDays}
            onChange={(e) =>
              handleFieldChange('slaAlertDays', Number(e.target.value))
            }
            allowNegative={false}
            inputProps={{ maxLength: 2 }}
            sx={textFieldDefaultStyle}
          />
        </Grid>
        <Grid item xs={6}>
          <NumericFormat
            label="aviso de prazo expirado (dias após vencimento)"
            helperText="notificar quando o prazo da OS já estiver expirado"
            customInput={TextField}
            value={group.slaLimitDays}
            onChange={(e) =>
              handleFieldChange('slaLimitDays', Number(e.target.value))
            }
            allowNegative={false}
            inputProps={{ maxLength: 2 }}
            sx={textFieldDefaultStyle}
          />
        </Grid>
      </Grid>
      <Stack direction="row" mt="20px">
        <FormControlLabel
          label="dias corridos"
          control={
            <Checkbox
              checked={group.slaUseBusinessDay === false}
              onChange={() =>
                handleFieldChange(
                  'slaUseBusinessDay',
                  group.slaUseBusinessDay === false ? null : false
                )
              }
            />
          }
        />
        <FormControlLabel
          label="dias úteis"
          control={
            <Checkbox
              checked={group.slaUseBusinessDay === true}
              onChange={() =>
                handleFieldChange(
                  'slaUseBusinessDay',
                  group.slaUseBusinessDay === true ? null : true
                )
              }
            />
          }
        />
      </Stack>
    </Grid>
  );
});

export default TypologyGroupSLA;
